// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue 		from 'vue'
import App 		from './App'
import router 	from './router'
import store 	from './store/index'
import Langs    from './mixins/Lang.js'

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

// import isotope from 'isotope-layout';
// import isotope from 'vueisotope'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import '@fortawesome/fontawesome-free/css/all.css'
import './assets/css/bootstrap.min.css'
import './assets/css/responsive.css'
import './assets/vendors/themify-icon/themify-icons.css'


import "./assets/vendors/bootstrap-selector/css/bootstrap-select.min.css"
import "./assets/vendors/themify-icon/themify-icons.css"
// import "./assets/vendors/flaticon/flaticon.css"
import "./assets/vendors/animation/animate.css"
import "@/assets/vendors/owl-carousel/assets/owl.carousel.min.css"
import "./assets/vendors/magnify-pop/magnific-popup.css"
import "./assets/vendors/nice-select/nice-select.css"
import "./assets/vendors/elagent/style.css"

import "./assets/vendors/scroll/jquery.mCustomScrollbar.min.css"

import './assets/css/style.css'
import './assets/css/responsive.css'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	mixins: [Langs],
	components: { App },
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js